// extracted by mini-css-extract-plugin
export default {"wrapper":"inputBlockRegistation-module--wrapper--3mFdM","withoutBorder":"inputBlockRegistation-module--withoutBorder--2TmV6","title":"inputBlockRegistation-module--title--w8u3C"};